import React from "react";
import { useSearchParams } from "react-router-dom";

const useLogicSearchParams = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    /**
     * Adds or updates multiple query parameters in the URL search parameters.
     *
     * @param {Object} params - An object containing key-value pairs of query parameters to add or update.
     */
    const addQueryParams = (params) => {
        const newParams = new URLSearchParams(searchParams);
        // Object.keys(params).forEach((key) => {
        //     if (newParams.has(key)) {
        //         newParams.set(key, params[key]); // Modifie la clé existante
        //     } else {
        //         newParams.append(key, params[key]); // Ajoute la nouvelle clé
        //     }
        // });
        setSearchParams(params);
    };

    return {
        searchParams,
        setSearchParams,
        addQueryParams,
    };
};

export default useLogicSearchParams;
